// Fish data with nutrients merged from CSV (with fallback support)
import { fishDatabase, FishSpecies } from './fish_db';
import { getNutrientData } from './nutrientLoader';

/**
 * Get nutrients for a fish species
 * Tries to load from CSV first, falls back to embedded data if CSV fails
 */
export function getFishNutrients(fishId: string): FishSpecies['nutrients_per_100g_fallback'] | undefined {
  // Try to get from CSV first
  const csvNutrients = getNutrientData(fishId);
  if (csvNutrients) {
    return csvNutrients;
  }

  // Fall back to embedded data
  const fish = fishDatabase.find(f => f.id === fishId);
  return fish?.nutrients_per_100g_fallback;
}

/**
 * Get fish species data with nutrients
 * Returns fish data with nutrients from CSV (or fallback if CSV fails)
 */
export function getFishWithNutrients(fishId: string): (FishSpecies & { nutrients_per_100g: FishSpecies['nutrients_per_100g_fallback'] }) | undefined {
  const fish = fishDatabase.find(f => f.id === fishId);
  if (!fish) return undefined;

  const nutrients = getFishNutrients(fishId);
  if (!nutrients) return undefined;

  return {
    ...fish,
    nutrients_per_100g: nutrients
  };
}

/**
 * Get all fish with their nutrients
 */
export function getAllFishWithNutrients(): (FishSpecies & { nutrients_per_100g: FishSpecies['nutrients_per_100g_fallback'] })[] {
  return fishDatabase.map(fish => ({
    ...fish,
    nutrients_per_100g: getFishNutrients(fish.id) || fish.nutrients_per_100g_fallback
  }));
}
